<template>
  <div class="scenario_move">
    <draggable
        class="list-group"
        tag="ul"
        v-model="list"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false;sortNo();setAnswer()"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div class="move_each flex"
             v-for="element in list"
             :key="element.order">
          <div class="move_num">
            <span>{{ element.no }}</span>
          </div>
          <div class="move_block flex">
            <p>{{ element.name }}</p>
            <i class="fas fa-bars"></i>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import '@/assets/css/scenario_educationFund.css'
import draggable from "vuedraggable";
import {dispatch} from "vuex-pathify";

const message = [
  "教學理念",
  "雙語授課",
  "離家近",
  "學費",
  "師資",
  "軟硬體設備",
  "環境／空間"
];
export default {
  name: "draggable-option",
  display: "Transitions",
  order: 7,
  components: {
    draggable
  },
  props: {
    page_no: Number,
    options: Array,
  },
  data() {
    return {
      list: [],
      drag: false,
      moduleName: ''
    };
  },
  methods: {
    sortNo() {
      this.list.map((item, index) => item.no = index + 1)
    },
    setAnswer() {
      dispatch(this.moduleName + '/setPostData', {page_no: this.page_no, page_answer: Number(this.list[0].value)})
    }
  },
  created() {
    this.moduleName = store.get('moduleName')
    this.list = this.options.map((item, index) => {
      return {
        name: item.label,
        order: index + 1,
        no: index + 1,
        value: item.value
      }})
    this.setAnswer()
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style>
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>